<template>
  <div
    class="flex shrink-0"
    :style="{ width: size + 'px', height: size + 'px' }"
  >
    <img
      :key="path"
      v-lazy-load
      :src="path"
      alt=""
      class="size-full object-cover"
      :class="form === 'circle' ? 'rounded-full' : 'rounded'"
    />
  </div>
</template>

<script setup>
defineProps({
  path: {
    type: String,
    default: '',
  },

  size: {
    type: Number,
    default: 32,
  },

  form: {
    type: String,
    default: 'square',
    validate: (value) => ['square', 'circle'].includes(value),
  },
});
</script>

<style lang="scss"></style>
